export default [
  {value: 1, name: '半月保养'},
  {value: 2, name: '季度保养'},
  {value: 3, name: '半年保养'},
  {value: 4, name: '年度保养'},
  {value: 51, name: '按需保养-3个月去一次'},
  {value: 52, name: '按需保养-2个月去一次'},
  {value: 53, name: '按需保养-1个月去一次'},
]